import { Toast } from 'vant';

// 黑喵渠道不展示 iOS 成长经验文案，保留函数方便复用源应用调用结构。
export const getExperStr = () => '';

export const isInteractionOk = (res) => {
  if (!res || res.success === false) return false;
  if (res.data && res.data.status === 0) return false;
  return true;
};

export const isForumErrorShown = (error) =>
  !!(error && (error.__forumErrorShown || (error.data && error.data.__forumErrorShown)));

export const getForumErrorMessage = (error) => {
  if (!error) return '';
  return (
    error.__forumErrorMessage ||
    error.msg ||
    error.message ||
    (error.data && (error.data.__forumErrorMessage || error.data.msg || error.data.message)) ||
    ''
  );
};

export const toastForumError = (error, fallbackMsg = '操作失败，请稍后再试') => {
  if (isForumErrorShown(error)) return;
  Toast(getForumErrorMessage(error) || fallbackMsg);
};

export const toastInteraction = (res, options = {}) => {
  if (isInteractionOk(res)) {
    if (options.successMsg) {
      Toast(`${options.successMsg}${getExperStr(res && res.data && res.data.experience)}`);
    }
    return true;
  }
  toastForumError(res, options.fallbackMsg || '操作失败，请稍后再试');
  return false;
};
